import { render, staticRenderFns } from "./notelist.vue?vue&type=template&id=4e821088&scoped=true"
import script from "./notelist.vue?vue&type=script&lang=js"
export * from "./notelist.vue?vue&type=script&lang=js"
import style0 from "./notelist.vue?vue&type=style&index=0&id=4e821088&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e821088",
  null
  
)

export default component.exports